/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly itemId: string | null;
        readonly cmsId: number | null;
        readonly link: string | null;
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly contemporaryTrackingString: string | null;
    } | null> | null;
    readonly " $refType": "HpRespHeroModule_componentModule";
};
export type HpRespHeroModule_componentModule$data = HpRespHeroModule_componentModule;
export type HpRespHeroModule_componentModule$key = {
    readonly " $data"?: HpRespHeroModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespHeroModule_componentModule",
  "type": "HeroModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "itemId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "contemporaryTrackingString",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'aa135c0b8f6ddb2a2dd5b17275564beb';
export default node;
